/* eslint-disable react/no-danger */
/* eslint-disable react/no-unstable-nested-components */
import { Typography } from 'antd';
import { useDebounce } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StatusBadge from '../../../components/Badges/StatusBadge';
import AlumlyButton from '../../../components/AlumlyButton';
import AlumlyDataGrid from '../../../components/AlumlyDataGrid';
import { ErrorCodeEnum } from '../../../enums/errorCode';
import { PermissionEnum } from '../../../enums/permission';
import { RouteNameEnum } from '../../../enums/routeName';
import { ServiceNameEnum } from '../../../enums/serviceName';
import usePermission from '../../../hooks/usePermission';
import useServices from '../../../hooks/useServices';
import { AxiosService } from '../../../utils/axiosService';
import { DateTimeUtils } from '../../../utils/dateTime';
import ModalCreateBoUser from './modalCreateBoUser';
import FormFilterOrderTransactionList, { FilterOrderTransactionT } from './FormFilterBOActivityLogList';

const BOActivityLogList: React.FC = () => {
  const navigate = useNavigate();

  const [selectedFilter, setSelectedFilter] = useState<FilterOrderTransactionT>();
  const [boUserActivityLogs, setBoUserActivityLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 10,
    rowCount: 0,
    loading: false,
  });
  const debouncedValue = useDebounce(selectedFilter, { wait: 300 });
  const DisplayContentHTML = (Content: any): any => {
    const { Content: inSide } = Content;
    return <div dangerouslySetInnerHTML={{ __html: inSide }} />;
  };

  const { service: getBoUserActivityLogService } = useServices(ServiceNameEnum.boUser.activityLog);

  const getUserActivityLogs = async (): Promise<void> => {
    const pageOptions = { page: pagination.page + 1 };
    const filterOptions = selectedFilter;
    const queryString = { ...pageOptions, ...filterOptions };
    const { data, error } = await getBoUserActivityLogService.get({ queryString });
    if (data) {
      setBoUserActivityLogs(data.items);
      setTotal(data.pagination!.total);
      setPagination({
        page: data.pagination.currentPage - 1,
        pageSize: data.pagination.perPage,
        rowCount: data.pagination.total,
        loading: false,
      });
    } else if (error) {
      const errorResponse = AxiosService.getErrorResponse(error);
      toast.error(errorResponse?.message, { toastId: 'allToast' });
      if (errorResponse?.code === ErrorCodeEnum.boUser.userNoPermission) {
        navigate(RouteNameEnum.dashboard.index);
      }
    }
  };

  const columns: any[] = [
    {
      field: 'createAt',
      headerName: 'Date & Time',
      width: 220,
      valueGetter: (params: any) =>
        `${params.row?.createAt ? DateTimeUtils.dateTimeFormat(params.row?.createAt) : ''}`,
    },
    {
      field: 'feature',
      headerName: 'Feature',
      width: 220,
      valueGetter: (params: any) =>
        `${params.row?.feature || '-'} `,
    },
    {
      field: 'activity',
      headerName: 'Activity',
      width: 220,
      valueGetter: (params: any) =>
        `${params.row?.activity || '-'} `,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 200,
      flex: 1,
      renderCell: (params: any) => (
        <div style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
          <DisplayContentHTML Content={params.row?.description} />
        </div>
      ),
    },
    {
      field: 'adminUser',
      headerName: 'Admin',
      width: 200,
      valueGetter: (params: any) =>
        `${params.row?.adminUser || '-'}`,
    },
  ];

  const resetPage = (): void => {
    setPagination({
      ...pagination,
      page: 0,
    });
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, loading: true }));
    getUserActivityLogs();
  }, [pagination.page, debouncedValue]);

  return (
    <div style={{ marginTop: 32 }}>
      <FormFilterOrderTransactionList
        resetPage={resetPage}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />
      <div style={{
        marginTop: 32, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}
      >
        <div style={{ display: 'flex', justifyContent: 'left' }}>
          <Typography.Text style={{ fontSize: '14px', paddingRight: 8 }}>
            Total
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 'bold', fontSize: '14px' }}>
            {`${total}  Activity`}
          </Typography.Text>
        </div>
      </div>
      <div style={{ marginTop: 32 }}>
        <AlumlyDataGrid
          rows={boUserActivityLogs}
          columns={columns}
          {...pagination}
          rowHeight={80}
          height={910}
          paginationMode="server"
          onPageChange={(page: number) => setPagination((prev) => ({ ...prev, page }))}
          disableColumnMenu
        />
      </div>
    </div>
  );
};
export default BOActivityLogList;
